<template>
  <div id="Content">
    <!-- {{ outputs }} -->
    <!-- <Header/> -->
    <div v-if="dialogInfo.active" class="dialogInfo">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square" viewBox="0 0 16 16">
        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
        <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
        </svg>
        {{dialogInfo.text}}
      <button @click="onCancel">X</button>
    </div>

    <div v-if="inputs.glebokosc_szafy.active || outputs.akumulator_user.value" class="topInfo">
      <button @click="changeDepth()" v-if="inputs.glebokosc_szafy.active">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-square" viewBox="0 0 16 16">
          <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
        </svg> -->
        {{$t('message.recznie_dobrana_glebokosc')}}
      </button>
      <button @click="changeBatteryUser()" v-if="outputs.akumulator_user.value">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-square" viewBox="0 0 16 16">
          <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
        </svg> -->
        {{$t('message.recznie_dobrane_akumulatory')}}
      </button>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-sm kolumna kolumna-1">
          <DaneWejsciowe/>
          <Urzadzenia/>
          <MetodaKontroli/>
          <WizualizacjaStacji/>
        </div>
        <div class="col-sm">
          <Wizualizacja/>
        </div>
        <div class="col-sm kolumna kolumna-3">
          <DaneWyjsciowe/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from '../assets/json/config'
import Szafy from '../assets/json/szafy'
import Akcesoria from '../assets/json/akcesoria'
import Akumulatory from '../assets/json/akumulatory'
import Zasilacze from '../assets/json/zasilacze'
import ListwyD from '../assets/json/listwy_dystrybucji'
import ListwyZ from '../assets/json/listwy_zabezpieczajace'
import Materialy from '../assets/json/materialy'

import DaneWejsciowe from './DaneWejsciowe'
import Urzadzenia from './Urzadzenia'
import MetodaKontroli from './MetodaKontroli'
import DaneWyjsciowe from './DaneWyjsciowe'
import Wizualizacja from './Wizualizacja'
import Header from './Header.vue'
import WizualizacjaStacji from './WizualizacjaStacji'

import { mapGetters } from 'vuex'
import { app } from '../mixins/app'
import { materials } from '../mixins/materials'
import { calculation } from '../mixins/calculation'

export default {
  name: 'Content',
  mixins: [app, calculation, materials],
  data () {
    return {
      config: Config,
      produkty_szafy: Szafy,
      produkty_akcesoria: Akcesoria,
      produkty_akumulatory: Akumulatory,
      produkty_zasilacze: Zasilacze,
      produkty_listwy_d: ListwyD,
      produkty_listwy_z: ListwyZ,
      produkty_materialy: Materialy,
      userLog: false
    }
  },
  computed: {
    ...mapGetters('app', ['dialogInfo']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaAkcesoria']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaZasilacze']),
    ...mapGetters('products', ['ListaListwyD']),
    ...mapGetters('products', ['ListaListwyZ']),
    ...mapGetters('products', ['ListaMaterialy'])
  },
  components: {
    DaneWejsciowe,
    Urzadzenia,
    MetodaKontroli,
    DaneWyjsciowe,
    Wizualizacja,
    Header,
    WizualizacjaStacji
  },
  methods: {
    get_config () {
      this.$store.commit('app/SET_CONFIG', this.config)
      // console.log(this.produkty_szafy)
    },
    get_szafy () {
      this.$store.commit('products/SET_LIST_SZAFY', this.produkty_szafy)
      this.changeValueOutputs('szafa', 'array', this.produkty_szafy[0])
      this.check_depth_rack(this.produkty_szafy[0].attributes.wysokosc, this.produkty_szafy)
    },
    get_akcesoria () {
      this.$store.commit('products/SET_LIST_AKCESORIA', this.produkty_akcesoria)
      // console.log(this.produkty_akcesoria)
    },
    get_akumulatory () {
      this.$store.commit('products/SET_LIST_AKUMULATORY', this.produkty_akumulatory)
      // console.log(this.produkty_akcesoria)
    },
    get_zasilacze () {
      this.$store.commit('products/SET_LIST_ZASILACZE', this.produkty_zasilacze)
      // console.log(this.produkty_akcesoria)
    },
    get_listwy_d () {
      this.$store.commit('products/SET_LIST_LISTWY_D', this.produkty_listwy_d)
      // console.log(this.produkty_akcesoria)
    },
    get_listwy_z () {
      this.$store.commit('products/SET_LIST_LISTWY_Z', this.produkty_listwy_z)
      // console.log(this.produkty_akcesoria)
    },
    get_materialy () {
      this.$store.commit('products/SET_LIST_MATERIALY', this.produkty_materialy)
      // console.log(this.produkty_akcesoria)
    },
    changeDepth () {
      this.changeValueInputs('glebokosc_szafy', 'active', false)
    },
    changeBatteryUser () {
      this.changeValueOutputs('akumulator_user', 'value', false)
      this.obliczenia_sprzetu()
    },
    onCancel () {
      this.$store.commit('app/SET_DIALOG_INFO', {'active': false, 'text': ''})
    }
  },
  created () {
    this.get_config()
    this.get_szafy()
    this.get_akcesoria()
    this.get_akumulatory()
    this.get_zasilacze()
    this.get_listwy_d()
    this.get_listwy_z()
    this.get_materialy()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#Content {
  background: #efefef;
}
.row {
margin-top: 15px;
}
.topInfo {
width: 100%;
  padding: 4px;
  background: none;
  text-align: left;
  color: red;
  position: fixed;
  z-index: 2;
  top: 80px;
  display: grid;
}
.topInfo button {
background: white;
  border: none;
  color: #055e94;
  cursor: pointer;
  min-width: 300px;
  margin: 2px auto;
}
.topInfo button:hover {
  color: rgb(29, 132, 250);
}
.dialogInfo {
  width: 100%;
  padding: 10px;
  background: #fff;
  text-align: center;
  color: red;
  font-size: 16px;
  font-weight: bold;
}
.dialogInfo svg{
  color: red;
  font-size: 16px;
  font-weight: bold;
}
.dialogInfo button{
  background: none;
  border:none;
  color: red;
  cursor: pointer;
  float:right
}
</style>



// WEBPACK FOOTER //
// src/components/Content.vue